export const AttentionItemStyle = {
	wrapper: {
		display: 'flex',
		alignItems: 'start',
		padding: '6px 12px 6px 24px',
		position: 'relative',
	},

	content: {
		flex: '1',
		cursor: 'pointer',
	},

	description: {
		display: '-webkit-box',
		overflow: 'hidden',
		webkitLineClamp: '2',
		WebkitBoxOrient: 'vertical',
		color: 'var(--neutral-500)',
	},
	title: {
		fontWeight: 700,
		marginBottom: '4px',
	},
	icon: {
		position: 'absolute',
		top: 5,
		left: -8,

		'& svg circle': {
			fill: 'red',
		},
	},
	date: {
		color: 'var(--neutral-300)',
		fontSize: '12px',
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 180px',
			width: '100%',

			'@media (max-width: 1199.98px)': {
				padding: '48px 120px',
			},

			'@media (max-width: 639.98px)': {
				padding: '40px 20px 20px',
			},
		},
	},
};
